export default __webpack_public_path__ + "static/media/signUp.06c47aa2.svg";